module.exports = __webpack_public_path__ + "img/mono-logo.152072dc.svg";